import React from "react";
import ReactDOM from "react-dom/client";
// import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css"
import Footer from "./Pages/Footer";
import App from "./App";
import Navbar from "./Pages/Navbar";
// import App from "App";
// import Footer from "Pages/Footer";
// import Navbar from "Pages/Navbar";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  //   {/* <BackgroundColorWrapper> */}
  //   {/* <BrowserRouter>
  //       <Routes>
  //         <Route path="/admin/*" element={<AdminLayout />} />
  //         <Route path="/rtl/*" element={<RTLLayout />} />
  //         <Route
  //           path="*"
  //           element={<Navigate to="/admin/dashboard" replace />}
  //         />
  //         <Route path="/" element={<Sidebar />} />
  //       </Routes>
  //     </BrowserRouter> */}
  //   <App />
  //   {/* </BackgroundColorWrapper> */}
  // </React.StrictMode>


  <React.StrictMode>
    <Navbar />
    <App />
    <Footer />
  </React.StrictMode>
);



